"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankCode = void 0;
var BankCode;
(function (BankCode) {
    BankCode["BancoDoBrasil"] = "001";
    BankCode["Bancoob"] = "756";
    BankCode["Banrinsul"] = "041";
    BankCode["Bradesco"] = "237";
    BankCode["Inter"] = "077";
    BankCode["Itau"] = "341";
    BankCode["Original"] = "212";
    BankCode["Santander"] = "033";
    BankCode["Sicredi"] = "748";
})(BankCode = exports.BankCode || (exports.BankCode = {}));
//# sourceMappingURL=BankCode.js.map